import React from "react"
import { Grid, TextField, MenuItem, Autocomplete, Typography } from "@mui/material"

const TabRetenciones = ({ pago, handleInputChange, facturasCobrar, opcionesRetencion }) => {
  const esIva = pago.tipo_pago === "RI"

  // Handler para asegurar que solo se ingresen números en campos estrictos
  const handleNumericInput = (field, value, maxLength) => {
    const onlyNums = value.replace(/[^0-9]/g, "")
    if (onlyNums.length <= maxLength) {
      handleInputChange(field, onlyNums)
    }
  }

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="subtitle2" color="primary" sx={{ mb: -1 }}>
          {esIva ? "Detalle de Retención de IVA" : "Detalle de Retención en la Fuente"}
        </Typography>
      </Grid>

      {/* 1. Factura a la que aplica la retención */}
      <Grid item xs={12} md={6}>
        <TextField
          select
          fullWidth
          label="Factura a Aplicar *"
          size="small"
          value={pago.facnumfac_aplicada || ""}
          onChange={(e) => handleInputChange("facnumfac_aplicada", e.target.value)}
        >
          {facturasCobrar.map((fac) => (
            <MenuItem key={`${fac.facnumfac}-${fac.facsecuen}`} value={fac.facnumfac}>
              {fac.facnumfac} (Cuota {fac.facsecuen} - Saldo: ${fac.saldo_neto})
            </MenuItem>
          ))}
          {facturasCobrar.length === 0 && (
            <MenuItem value="" disabled>
              No hay facturas en la planilla
            </MenuItem>
          )}
        </TextField>
      </Grid>

      {/* 2. Porcentaje de Retención (Catálogo) */}
      <Grid item xs={12} md={6}>
        <Autocomplete
          options={opcionesRetencion || []}
          getOptionLabel={(option) => option.label || ""}
          value={(opcionesRetencion || []).find((r) => r.id === pago.porcentaje_ret) || null}
          onChange={(e, nv) => handleInputChange("porcentaje_ret", nv ? nv.id : "")}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => <TextField {...params} label="Porcentaje de Retención *" size="small" />}
        />
      </Grid>

      {/* 3. Base Imponible */}
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label={esIva ? "Base Imponible (IVA) *" : "Base Imponible (Subtotal) *"}
          size="small"
          type="number"
          value={pago.base_retencion}
          onChange={(e) => handleInputChange("base_retencion", e.target.value)}
          inputProps={{ min: 0, step: "0.01" }}
        />
      </Grid>

      {/* 4. Serie del Comprobante (Ej. 001001) */}
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Serie (6 dígitos) *"
          size="small"
          placeholder="001001"
          value={pago.serie_ret || ""}
          onChange={(e) => handleNumericInput("serie_ret", e.target.value, 6)}
          helperText={`${(pago.serie_ret || "").length}/6`}
          error={(pago.serie_ret || "").length > 0 && (pago.serie_ret || "").length !== 6}
        />
      </Grid>

      {/* 5. Secuencial del Comprobante */}
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Secuencial (9 dígitos) *"
          size="small"
          placeholder="000000001"
          value={pago.secuencial_ret || ""}
          onChange={(e) => handleNumericInput("secuencial_ret", e.target.value, 9)}
          helperText={`${(pago.secuencial_ret || "").length}/9`}
          error={(pago.secuencial_ret || "").length > 0 && (pago.secuencial_ret || "").length !== 9}
        />
      </Grid>

      {/* 6. Autorización SRI */}
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Autorización SRI (10 o 49 dígitos) *"
          size="small"
          value={pago.autorizacion || ""}
          onChange={(e) => handleNumericInput("autorizacion", e.target.value, 49)}
          helperText={`${(pago.autorizacion || "").length}/49`}
          error={
            (pago.autorizacion || "").length > 0 &&
            (pago.autorizacion || "").length !== 10 &&
            (pago.autorizacion || "").length !== 49
          }
        />
      </Grid>
    </>
  )
}

export default TabRetenciones
